import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.scss";
import "./Modal.scss";
import Routes from "./Routes";
import { Globals } from "./constants";
import { Helmet } from "react-helmet";

import { isVideoAllowed, autoLogin } from "./HelperFunctions";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssLoaded: false,
      userLoggedIn: localStorage.getItem("user_logged_in"),
      // loginCheck: false,
      user:
        localStorage.getItem("user") &&
        localStorage.getItem("user") !== "undefined"
          ? JSON.parse(localStorage.getItem("user"))
          : null,
      msisdn: "",
      userTelco: Globals.telco
        ? Globals.telco
        : localStorage.getItem("user") &&
          localStorage.getItem("user") !== "undefined"
          ? JSON.parse(localStorage.getItem("user")).telco
          : "",
      userPhone: "",
      userStatus: "",
      userSubscribeStatus: "",
      notificationsPopupShown: false,
      appPathIos: Globals.ios,
      appPath: Globals.android,
      marketPath: Globals.androidMarket,
      isVideoAllowed: false,
      isRegionChecked: false,
      noVideoReason: "This video content is not available in your region!",
      isEasypaisaSubscription:
        localStorage.getItem("user") &&
        localStorage.getItem("user") !== "undefined"
          ? JSON.parse(localStorage.getItem("user")).isEasypaisaSubscription
          : false,
    };
    this.checkSessionLive = this.checkSessionLive.bind(this);

    localStorage.setItem("isPlayed", "false");
    console.log("set", "encode", encodeURIComponent("k_$=S7hjsh"));
    console.log("set", "dencode", decodeURIComponent("k_%24%3DS7hjsh"));
  } //constructor

  hidePleaseWait() {
    document.getElementById("pleaseWait").classList.add("d-none");
  }

  showNotificationsPopup() {
    let notificationsPopupShown = this.state.notificationsPopupShown;
    if (!notificationsPopupShown) {
      if ("Notification" in window) {
        if (Notification && Notification.permission === "default") {
          // this.requestNotificationPermission();
          this.setState({ notificationsPopupShown: true });

          if (document.getElementById("btn-notifications"))
            document.getElementById("btn-notifications").click();
        }
      }
    }
  }
  requestNotificationPermission() {
    Notification.requestPermission(function(permission) {
      if (!("permission" in Notification)) {
        Notification.permission = permission;
      }
    });
  }

  downloadApp(e) {
    let sUsrAg = navigator.userAgent,
      win,
      url;
    if (sUsrAg.indexOf("Android") > -1) {
      url = this.state.appPath;
      window.open(url);
    } else {
      url = this.state.appPathIos;
      win = window.open(url, "_blank");
      win.focus();
    }
  }
  async componentDidMount() {
    if (this.state.cssLoaded === false) {
      this.setState({ cssLoaded: true });
      switch (Globals.cssFor) {
        case "mobilink":
          import("./css/mobilink.css?v=1");
          break;
        case "cricwick":
          import("./css/cricwick.css?v=1.7");
          break;
        case "zain":
          import("./css/zain.css?v=1.0");
          break;
        case "ufone":
          import("./css/ufone.css?v=1.0");
          break;
        case "zong":
          import("./css/zong.css?v=1.0");
          break;
        default:
          console.log("unknown telco");
      }

      import("./css/common.css"); // for color red only
    }

    if (!this.state.userLoggedIn) {
      //autologin; if user is redirected from campaign page with 'q' in queryparameter
      //          or number found in header for 'zain ksa', 'zain kw', 'mobily'
      autoLogin(Globals, window.location.search)
        .then((res) => {
          // this.setState({loginCheck:true});
          window.location.href = "/";
          return false;
        })
        .catch((res) => {
          // this.setState({loginCheck:true});
          if (res.msisdn) {
            this.setState({ msisdn: res.msisdn });
          }
          // console.log('tahir autologin fail ',res)
          this.hidePleaseWait();
        });
    } else {
      this.hidePleaseWait();
    }

    let user = JSON.parse(localStorage.getItem("user"));
    if (user && user.subscribed) {
      let userStatus;
      if (user.subscribed === 1) {
        userStatus = "Active";
      } else if (user.subscribed === 2) {
        userStatus = "In Active";
      } else if (user.subscribed === 4) {
        userStatus = "Free Trial";
      } else {
        userStatus = "Un Available";
      }
      this.setState({
        userPhone: user.phone,
        userSubscribeStatus: user.subscribed,
        userStatus: userStatus,
        userLoggedIn: true,
        userTelco: user.telco,
      });
    }

    isVideoAllowed(Globals)
      .then((res) => {
        let isVideoAllowed = true;
        let setState = {};
        if (
          this.state.userStatus === "Low Balance" &&
          !Globals.allowLowBalance
        ) {
          isVideoAllowed = false;
          setState.noVideoReason =
            "Please recharge your account to view this content";
        }
        setState.isVideoAllowed = isVideoAllowed;
        setState.isRegionChecked = true;
        if (Globals.pk.android && res === "PK") {
          setState.appPathIos = Globals.pk.ios;
          setState.appPath = Globals.pk.android;
          setState.marketPath = Globals.pk.androidMarket;
        }
        this.setState(setState);
        // console.log('video content is allowed in this region');
      })
      .catch((res) => {
        if (res === 2) {
          //findregion api failed
          let isVideoAllowed = true;
          if (
            this.state.userStatus === "Low Balance" &&
            !Globals.allowLowBalance
          ) {
            isVideoAllowed = false;
            this.setState({
              noVideoReason:
                "Please recharge your account to view this content",
            });
          }
          this.setState({
            isVideoAllowed: isVideoAllowed,
            isRegionChecked: true,
          });
          // console.log('video allowed error (api fail)', res);
        } else {
          //region mismatch
          this.setState({ isVideoAllowed: false, isRegionChecked: true });
          // console.log('video allowed error (region mismtach)', res);
        }
      });

    // setTimeout(this.showNotificationsPopup, 15000);
    // this.checkSessionLive();
    // setInterval(this.checkSessionLive, 3600000);
  }

  checkSessionLive() {
    if (this.state.userLoggedIn) {
      var now = new Date();
      var earlier = new Date();
      earlier.setHours(now.getHours() - 1);
      let user = this.state.user;
      if (
        (user && (!user.setTime || user.setTime < earlier)) ||
        (!user && this.state.userLoggedIn)
      ) {
        localStorage.removeItem("user");
        localStorage.removeItem("user_logged_in");
        this.setState({ userLoggedIn: false });
      } else {
        // valid
      }
    }
  }

  render() {
    // console.log("Render Starting");
    // alert("Render Starting 3");
    return (
    <BrowserRouter>
        <div>
          <div id={'pleaseWait'}>
            <img src='/images/pleasewait.gif' />
          </div>
           <Routes {...this.state} /> 
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
